import React, { ReactNode, useContext } from 'react';

import Button, { ButtonStyle } from '@components/Button';
import { WizardContext } from '@components/Wizard/Wizard';

interface IProps {
  children: ReactNode | ReactNode[];
}

function WizardPreviousButton({ children }: IProps) {
  const { stepIndex, setStepIndex } = useContext(WizardContext);

  if (stepIndex === 0) {
    return null;
  }
  return (
    <Button style={ButtonStyle.Secondary} onClick={() => setStepIndex(stepIndex - 1)}>
      {children}
    </Button>
  );
}

export default WizardPreviousButton;
